import { motion } from "framer-motion";

const CHILD = [["Child", "Every journey starts with one child."], ["Learn", "Water-safety education"], ["Swim", "Water competency"], ["Protect", "Barriers + supervision"], ["Equip", "Life-jacket knowledge"], ["Prepare", "Family CPR & emergency education"], ["Engage", "Community participation"]];
const POND = [["Report", "A resident submits a pond"], ["Assess", "Structured program review"], ["Owner Authorization", "Written permission"], ["Professional Review", "Engineering where appropriate"], ["Design", "Appropriate barrier"], ["Permit / Approval", "Where required"], ["Sponsor", "Every step gets a partner"], ["Build", "Qualified contractor"], ["Educate", "Community Safety Day"], ["Maintain", "Responsibility assigned"]];

const Track = ({ title, steps, color, testid }) => (
  <div className="rounded-3xl bg-white border border-sky-100 p-6 md:p-8 shadow-sm" data-testid={testid}>
    <p className="font-display uppercase text-xl font-bold" style={{ color }}>{title}</p>
    <ol className="mt-6 relative border-l-2 border-dashed ml-3" style={{ borderColor: color }}>
      {steps.map(([t, d], i) => (
        <motion.li key={t} className="ml-6 pb-5 last:pb-0" initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
          <span className="absolute -left-[11px] w-5 h-5 rounded-full ring-4 ring-white text-[10px] font-bold text-white flex items-center justify-center" style={{ background: color }}>{i + 1}</span>
          <p className="font-bold uppercase text-sm text-[#03045E]">{t}</p>
          <p className="text-sm text-slate-600">{d}</p>
        </motion.li>
      ))}
    </ol>
  </div>
);

export default function Journeys() {
  return (
    <div>
      <div className="grid md:grid-cols-2 gap-6">
        <Track title="Child Safety Journey" steps={CHILD} color="#0096C7" testid="journey-child" />
        <Track title="Community / Pond Safety Journey" steps={POND} color="#FF6B35" testid="journey-pond" />
      </div>
      <div className="mt-6 rounded-3xl bg-[#03045E] text-white p-6 md:p-8 text-center">
        <p className="text-xs uppercase tracking-[0.25em] text-sky-300 font-bold">They meet in the middle</p>
        <p className="font-display uppercase text-2xl md:text-3xl mt-2">Safer Child + Better Prepared Family + Stronger Community</p>
      </div>
    </div>
  );
}
